import { CLIENT_NAMES } from "../../data/content";

/**
 * ONE slow editorial marquee — the site's signature horizontal breath.
 * Native CSS animation. No JS. Doubled for seamless loop.
 */
export default function ClientTicker() {
  const list = [...CLIENT_NAMES, ...CLIENT_NAMES];

  return (
    <section
      data-testid="client-ticker"
      className="ground-ink py-14 md:py-20"
    >
      <div className="wrap flex flex-wrap items-baseline justify-between gap-6 mb-8 md:mb-12">
        <div className="flex items-center gap-4">
          <span className="series-stamp on-ink blue">Trusted rooms</span>
          <span className="stamp-dim" style={{ color: "rgba(239, 231, 214, 0.6)" }}>30+ enterprises</span>
        </div>
        <span className="stamp-dim" style={{ color: "rgba(239, 231, 214, 0.6)" }}>Est. 2015</span>
      </div>

      <div className="marquee-viewport">
        <div className="editorial-marquee slow" aria-hidden="false">
          {list.map((c, i) => (
            <div key={i} className="flex items-center gap-[60px] shrink-0">
              <span
                className="font-hook-black text-[color:var(--paper)] whitespace-nowrap"
                style={{ fontSize: "clamp(48px, 6vw, 96px)", letterSpacing: "-0.02em" }}
              >
                {c}
              </span>
              <span className="text-[color:var(--pink)]" style={{ fontSize: 44, lineHeight: 1 }}>*</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
